import { getLocale } from './locales';

export const getDefaultHeaders = () => ({ 'Accept-Language': getLocale() });

export default {};
